import React from "react";
import "./NearbyAreas.scss";

const NEARBY_AREAS = [
  "Kensington, W8",
  "Chelsea, SW3",
  "Earl's Court, SW5",
  "South Kensington, SW7",
  "Knightsbridge, SW1X",
  "West Brompton, SW10",
  "Brompton, SW3 and SW7",
  "Gloucester Road, SW7",
  "Holland Park, W11 and W14",
  "Notting Hill, W11",
  "Fulham, SW6",
  "Belgravia, SW1X",
];

const ENABLED_SLUGS = [
  "estate-agents-in-kensington",
  "estate-agents-in-chelsea",
];

const NearbyAreas = ({ slug, title = "Nearby areas we cover" }) => {
  if (!ENABLED_SLUGS.includes(slug)) return null;

  return (
    <div className="nearby-areas">
      <h3 className="nearby-areas-title">{title}</h3>
      <ul className="nearby-areas-list">
        {NEARBY_AREAS.map((area) => (
          <li key={area}>{area}</li>
        ))}
      </ul>
    </div>
  );
};

export default NearbyAreas;